module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-10.84544ed9.svg";